/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconCirclePlus = createReactComponent("circle-plus", "IconCirclePlus", [
  ["path", { d: "M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0", key: "svg-0" }],
  ["path", { d: "M9 12h6", key: "svg-1" }],
  ["path", { d: "M12 9v6", key: "svg-2" }]
]);

export { IconCirclePlus as default };
//# sourceMappingURL=IconCirclePlus.js.map
